import React, { Component } from "react"

import * as styles from "./aboutBountyContest.module.scss"
import partnerLogoImg from "../../../../assets/sponsor-logo-pwc-hk.png"

import "../../../static.css"
import { TM } from "../../common/typography/trademark"

class AboutBountyContest extends Component {
  constructor(props) {
    super(props)
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  en() {
    return (
      <div className={styles.verticalApplicationsSection}>
        <h2>
          IronCAP
          <TM /> Bounty Contest
        </h2>

        <div className="row">
          <div className="col-md-12">
            IronCAP
            <TM /> is a patent-protected post-quantum cryptographic system based
            on Goppa Code-based cryptographic technology. It has embedded our
            proprietary subclass of (L, G) making it not only more secured but
            also has faster cryptographic operations (key generation,
            encryption, decryption) than the traditional Goppa Code-based
            technology (McEliece). We are asking the world to help proving our
            security by offering $100,000 to the first participant who manages
            to crack our cryptography.
          </div>
        </div>

        <div className="row top-buffer ">
          <div className="col-md-6">
            <div className={styles.aboutgroup}>
              <h3>Eligibility</h3>
              <ul>
                <li>Anyone with a Facebook, WeChat, or Google account </li>
                <li>Any country </li>
                <li>
                  You need to agree to the official Rules, Terms & Conditions as
                  set forth in the signup process.
                </li>
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>How it works</h3>
              <ul>
                <li>Register an account</li>
                <li>Login to the account</li>
                <li>Obtain the hash value of the original data</li>
                <li>Obtain the public key and the encrypted ciphertext</li>
                <li>
                  Submit what you believe is the original data and a paper in
                  PDF format detailing your method of cracking (There is no
                  limit on the number of attempts)
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-6">
            <div className={styles.aboutgroup}>
              <h3>Tools provided</h3>
              <ul>
                White paper of the underlying IronCAP
                <TM /> technology An encryption/decryption tool for experiments
                that uses a different keypair than the one used for this Bounty
                Contest
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>Prize claiming</h3>
              <ul>
                <li>Like a Bingo: First winner takes it all</li>
                <li>
                  Upon verification, winner will be announced and awarded a cash
                  prize of $100,000 Canadian Dollars ($1 CDN = approximately
                  $0.76 USD)
                </li>
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>Escrow</h3>
              <ul>
                <li>Fogler Rubinoff LLP (www.foglers.com)</li>
              </ul>
            </div>
          </div>
        </div>

        <br />
        <div className="row">
          <div className="col-md-12">
            <img
              src={partnerLogoImg}
              className="float-right"
              alt="partner logo"
            />
            <span className="float-right">
              <strong>Exclusive Sponsor</strong>
            </span>
          </div>
        </div>

        <div className="row">
          <div className={styles.disclaimer}>
            <u>Disclaimer</u>
            <p>
              By participating in the Bounty Contest, each entrant agrees to be
              bound by the Bounty Contest Rules. Entrants further agree to be
              bound by the decisions of the Company, which shall be final and
              binding in all respects. The Company reserves the right, in its
              sole discretion, to disqualify any entrant that the Company
              believes is: (a) violating the Bounty Contest Rules; (b) tampering
              or attempting to tamper with the entry process or the operation of
              the Bounty Contest, the Bounty Contest Website, or any related
              promotional website; (c) violating the terms of service,
              conditions of use and/or general rules or guidelines of any the
              Company’s property or service; and/or (d) acting in an
              unsportsmanlike or disruptive manner, or with intent to annoy,
              abuse, threaten or harass any other person.
            </p>
          </div>
        </div>
      </div>
    )
  }

  ct() {
    return (
      <div className={styles.verticalApplicationsSection}>
        <h2>
          IronCAP
          <TM /> 賞金比賽
        </h2>

        <div className="row">
          <div className="col-md-12">
            IronCAP
            <TM /> 是正在申請專利中的，基於Goppa編碼加密技術的後量子加密系統。
            它嵌入了我們專有的（L，G）子類，不僅更安全，而且密碼操作（密鑰生成、加密、解密）比傳統基於
            Goppa 編碼
            的技術（McEliece）更快。我們邀請各位來參與驗証我們的安全性並提供
            100,000 加元的賞金來奬勵第一位 成功破解密碼的參與者。
          </div>
        </div>

        <div className="row top-buffer ">
          <div className="col-md-6">
            <div className={styles.aboutgroup}>
              <h3>參與資格</h3>
              <ul>
                <li>擁有 Facebook, WeChat 或 Google 帳戶的用戶</li>
                <li>
                  您需要同意主辨機構的規則、條款以及註冊過程 <br />
                  中規定的條件。
                </li>
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>運作簡介</h3>
              <ul>
                <li>利用以上社交媒體賬戶注冊並獲取參加本次賞金比賽的帳戶</li>
                <li>登錄賞金比賽帳戶</li>
                <li>獲取原數據的哈希值</li>
                <li>獲取公鑰和加密後的密文</li>
                <li>
                  提交您認為是原數據的內容，並提交 PDF 格式的可
                  以詳細說明破解方法的完整文章（嘗試次數沒有限制）
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-6">
            <div className={styles.aboutgroup}>
              <h3>提供的工具</h3>
              <ul>
                <li>
                  IronCAP
                  <TM /> 技術白皮書
                </li>
                <li>
                  實驗式加密/解密工具 (該實驗式加密/解密工具用的
                  是一組與賞金比賽不同的密鑰對。
                </li>
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>領取獎金</h3>
              <ul>
                <li>像賓果遊戲：第一個獲勝者會獲得全都賞金</li>
                <li>
                  驗證後，將宣佈獲勝者，該獲勝者將獲得100,000加元 的現金獎
                  （1加元 = 約0.79美元）
                </li>
              </ul>
            </div>

            <div className={styles.aboutgroup}>
              <h3>第三方託管</h3>
              <ul>
                <li>Fogler Rubinoff LLP (www.foglers.com)</li>
              </ul>
            </div>
          </div>
        </div>

        <br />
        <div className="row">
          <div className="col-md-12">
            <img
              src={partnerLogoImg}
              className="float-right"
              alt="partner logo"
            />
            <span className="float-right">
              <strong>獨家贊助商</strong>
            </span>
          </div>
        </div>

        <div className="row">
          <div className={styles.disclaimer}>
            <u>免責聲明</u>
            <p>
              通過參加賞金比賽，每位參賽者均同意接受賞金比賽的規則約束。
              參賽者需要進一步同意接受主辨機構的最終決定
              及各項約束。主辨機構保留自行決定取消存在以下任一行爲的參賽者的參賽資格的權利：（a）違反了《賞金比賽規則》；
              （b）篡改或試圖篡改賞金比賽的參賽或運作的過程，賞金比賽網站或任何相關的促銷網站；（c）違反服務條款，主辨
              機構及其所屬公司財產或服務的使用條件和/或一般規則或準則；和/或（d）以違反體育道德或破壞性的方式行事，
              或意圖惹惱，辱駡，威脅或騷擾其他任何人。
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutBountyContest
